import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import { getNbDecks } from '@sorare/gameplay/src/lib/getNbDecks';

import { USInfoModal } from '@sorare/us-sports/src/components/USInfoModal';
import { Cards } from '@sorare/us-sports/src/components/gallery/Cards';

import { ClubLayout } from '@sorare/manager/src/components/profile/ClubLayout';
import { myClubFilters } from 'components/searchCards/cardFilters';

import {
  NbaUserCardsQuery,
  NbaUserCardsQueryVariables,
} from './__generated__/page.graphql';

const NBA_MY_CARDS_PAGE_QUERY = gql`
  query NbaUserCardsQuery($sport: Sport!) {
    currentUser {
      slug
      ...getNbDecks_publicUserInfoInterface
    }
  }
  ${getNbDecks.fragments.publicUserInfoInterface}
` as TypedDocumentNode<NbaUserCardsQuery, NbaUserCardsQueryVariables>;

const NBAMyCardsPage = () => {
  const { currentUser } = useCurrentUserContext();
  const { data } = useQuery(NBA_MY_CARDS_PAGE_QUERY, {
    variables: {
      sport: Sport.NBA,
    },
  });
  const nbDecks = getNbDecks(data?.currentUser);
  return (
    <ClubLayout cards>
      {currentUser && (
        <Cards
          sport={Sport.NBA}
          user={currentUser}
          galleryFilters={myClubFilters(nbDecks > 0)}
          PlayerDetailsComponent={USInfoModal}
        />
      )}
    </ClubLayout>
  );
};

export default NBAMyCardsPage;
